export default __webpack_public_path__ + "static/media/Insurancewebservicesbg.f3ed1d62.svg";